import {
  SEARCH_APP_REQUEST,
  SEARCH_WALLPAPER_REQUEST,
  SEARCH_POST_REQUEST,
  SEARCH_COURSE_REQUEST,
  UPDATE_SEARCH_PARAM,
  UPDATE_SEARCH_COUNT,
  SEARCH_WALLPAPER_HOT_REQUEST,
  SEARCH_POST_HOT_REQUEST,
  SEARCH_COURSE_HOT_REQUEST,
} from '../constants/searchResult';

export const getSearchApp = payload => ({
  type: SEARCH_APP_REQUEST,
  payload,
});
export const getSearchWallpaper = payload => ({
  type: SEARCH_WALLPAPER_REQUEST,
  payload,
});
export const getSearchPost = payload => ({
  type: SEARCH_POST_REQUEST,
  payload,
});
export const getSearchCourse = payload => ({
  type: SEARCH_COURSE_REQUEST,
  payload,
});

// 将数据存在redux中，数据更新就触发页面获取数据
export const updateSearchParam = payload => ({
  type: UPDATE_SEARCH_PARAM,
  payload,
});

// 将Count数据存在redux中
export const updateSearchCount = payload => ({
  type: UPDATE_SEARCH_COUNT,
  payload,
});

export const getSearchWallpaperHot = payload => ({
  type: SEARCH_WALLPAPER_HOT_REQUEST,
  payload,
});
export const getSearchPostHot = payload => ({
  type: SEARCH_POST_HOT_REQUEST,
  payload,
});
export const getSearchCourseHot = payload => ({
  type: SEARCH_COURSE_HOT_REQUEST,
  payload,
});
